import { render, staticRenderFns } from "./SearchOrganizationPage.vue?vue&type=template&id=2de16e10&scoped=true"
import script from "./SearchOrganizationPage.vue?vue&type=script&lang=ts"
export * from "./SearchOrganizationPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2de16e10",
  null
  
)

export default component.exports